<div class="container-filters" [class.justify-content-between]="config.date || config.refresh">
  <!-- refresh -->
  @if (config?.refresh?.length > 0) {
    <div class="container-filter-left">
      @for (refresh of config?.refresh; track refresh) {
        @if (refresh?.show) {
          <span class="action-filter">
            <button class="action-filter-btn btn-2" (click)="onClickRefresh(refresh)">
              <i class="fas fa-sync-alt"></i>
              <span [translate]="refresh.name || 'action.filter.refresh'"></span>
            </button>
            @if (refresh?.showDate && eventsAction.dataRefresh?.date) {
              <span class="refresh-date">({{$safeNavigationMigration(eventsAction.dataRefresh?.date) | date:'dd/MM/yyyy HH:mm:ss'}})</span>
            }
          </span>
        }
      }
    </div>
  }
  <!-- DATE -->
  @if (config.date) {
    <div class="date-time-picker" (onApply)=getDatesFromFilter($event) [configuredPreselectionId]="configuredPreselectionId" [customDates]="config.dateConfig">
    </div>
  }
  <!-- OTHER FILTERS -->
  <div class="action-filters">
    <!-- CUSTOM FILTER -->
    @if (config.customFilter) {
      <div class="sort-filter action-filter" [class.filter-active]="eventsAction.customFilter.filters[0] && eventsAction.customFilter.filters[0].value">
        <button class="action-filter-btn btn-2" (click)="onActionFilterBtnToggle($event.target)">
          <i class="fas fa-filter"></i>
          <span [translate]="'action.filter.customFilter'" class="translate--text"></span>
        </button>
        <div class="action-filter-content">
          <p class="action-filter-content-label"><span [translate]="'action.filter.filter_by'"
          class="translate--text"></span></p>
          <div class="action-filter-row">
            <div class="plus-wrap">
              <div class="action-filter-select-wrap" (click)="togglePlusContent($event.target, 'next')">
                <button class="action-filter-select"
                (click)="togglePlusContent($event.target, 'parent-next')">{{eventsAction.customFilter.value.value}}</button>
                <span class="icon-chevron-down plus-toggle"
                (click)="togglePlusContent($event.target, 'parent-next')"></span>
              </div>
              <div class="plus-content">
                <span class="icon-chevron-up plus-toggle"
                (click)="togglePlusContent($event.target, 'parent')"></span>
                <ul>
                  @for (item of config.customFilter.paramsToInclude; track item) {
                    <li
                      (click)="onChangeCustomFilter(item, $event.target)" class="plus-item"
                      [attr.data-customFilter-key]="item?.field.key">
                      {{ item.field.value }}
                    </li>
                  }
                </ul>
              </div>
            </div>
            <button (click)="onCustomFilterValidation()"
            class="action-filter-btn-add icon-check btn-group-validation"></button>
          </div>
        </div>
      </div>
    }
    <!-- DISPLAY COLUMN -->
    @if (config.column && config.column?.show !== false) {
      <div class="displayColumn action-filter"
        [class.filter-active]="!eventsAction.columns.columnDisplayedAreDefault()">
        <button [class.disabled]="groupEnabled === true" class="action-filter-btn btn-2"
          (click)="onActionFilterBtnToggle($event.target)">
          <i class="icon-columns"></i>
          <span [translate]="'action.filter.column'"></span>
        </button>
        <div class="action-filter-content">
          <p class="action-filter-content-label" [translate]="'action.filter.column'"></p>
          <div class="action-filter-row">
            <ul class="action-filter-parent-element">
              @for (column of eventsAction.columns.displayedColumnList; track column) {
                <li
                  class="action-filter-element small-item">
                  <span class="action-filter-row-label">{{column.column.value}}</span>
                  <button class="action-filter-remove" (click)="removeColumnItem(column.column.key)"><span
                  class="icon-minus-circle"></span></button>
                </li>
              }
            </ul>
            @if (!eventsAction.columns.allColumnAreDisplayed()) {
              <div class="plus-wrap">
                <button class="action-filter-btn-add icon-plus"
                (click)="togglePlusContent($event.target, 'next')"></button>
                <div class="plus-content">
                  <span class="icon-chevron-up plus-toggle"
                  (click)="togglePlusContent($event.target, 'parent')"></span>
                  <ul>
                    @for (item of eventsAction.columns.getHiddenColumnList(); track item) {
                      <li
                        class="plus-item" (click)="addColumnItem(item.column.key)">
                        {{item.column.value}}
                      </li>
                    }
                  </ul>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <!-- SORT -->
    @if (config.sort) {
      <div class="sort-filter action-filter" [class.filter-active]="!eventsAction.sort.sortIsDefault()">
        <button class="action-filter-btn btn-2 " (click)="onActionFilterBtnToggle($event.target)">
          <i class="fas fa-sort sort-icon"></i>
          <span [translate]="'action.filter.sort'"></span>
        </button>
        <div class="action-filter-content">
          <p class="action-filter-content-label" [translate]="'action.filter.sort_by'"></p>
          <div class="action-filter-row">
            <div class="plus-wrap">
              <div class="action-filter-select-wrap" (click)="togglePlusContent($event.target, 'next')">
                <button class="action-filter-select"
                (click)="togglePlusContent($event.target, 'parent-next')">{{eventsAction.sort.column.value}}</button>
                <span class="icon-chevron-down plus-toggle"
                (click)="togglePlusContent($event.target, 'parent-next')"></span>
              </div>
              <div class="plus-content">
                <span class="icon-chevron-up plus-toggle"
                (click)="togglePlusContent($event.target, 'parent')"></span>
                <ul>
                  @for (item of eventsAction.columns.fullColumnList; track item) {
                    <li
                      [class.d-none]="config.sort.paramsToInclude?.indexOf(item.column.key) === -1"
                      (click)="onChangeSortColumn(item.column, $event.target)" class="plus-item">
                    {{item.column.value}}</li>
                  }
                </ul>
              </div>
            </div>
            <div class="plus-wrap">
              <div class="action-filter-select-wrap" (click)="togglePlusContent($event.target, 'next')">
                <button class="action-filter-select" (click)="togglePlusContent($event.target, 'parent-next')">
                  @if (eventsAction.sort.order === 'ASC') {
                    <span [translate]="'action.filter.asc'" class="translate--text"
                    ></span>
                  } @else {
                    <span [translate]="'action.filter.desc'" class="translate--text"></span>
                  }
                </button>
                <span class="icon-chevron-down plus-toggle"
                (click)="togglePlusContent($event.target, 'parent-next')"></span>
              </div>
              <div class="plus-content">
                <span class="icon-chevron-up plus-toggle"
                (click)="togglePlusContent($event.target, 'parent')"></span>
                <ul>
                  <li (click)="onChangeSortOrder('ASC', $event.target)" class="plus-item">
                    {{'action.filter.asc' | translate}}
                  </li>
                  <li (click)="onChangeSortOrder('DESC', $event.target)" class="plus-item">
                    {{'action.filter.desc' | translate}}
                  </li>
                </ul>
              </div>
            </div>
            <button class="action-filter-btn-add icon-check" (click)="onChangeSort($event.target)"></button>
          </div>
        </div>
      </div>
    }

    <!-- GROUP -->
    @if (config.group) {
      <div class="sort-filter action-filter" [class.filter-active]="eventsAction.group.key">
        <button class="action-filter-btn btn-2" (click)="onActionFilterBtnToggle($event.target)">
          <i class="fas fa-columns group-icon"></i>
          <span [translate]="'action.filter.group'" class="translate--text"></span>
        </button>
        <!-- Popup -->
        <div class="action-filter-content">
          <p class="action-filter-content-label"><span [translate]="'action.filter.group_by'"
          class="translate--text"></span></p>
          <div class="action-filter-row">
            <div class="plus-wrap">
              <div class="action-filter-select-wrap" (click)="togglePlusContent($event.target, 'next')">
                <button class="action-filter-select"
                (click)="togglePlusContent($event.target, 'parent-next')">{{eventsAction.group.value}}</button>
                <span class="icon-chevron-down plus-toggle"
                (click)="togglePlusContent($event.target, 'parent-next')"></span>
              </div>
              <div class="plus-content">
                <span class="icon-chevron-up plus-toggle"
                (click)="togglePlusContent($event.target, 'parent')"></span>
                <ul>
                  <li (click)="onChangeGroup({key: null, value: 'Aucun'}, $event.target)" class="plus-item">
                    {{'action.filter.none' | translate}}
                  </li>
                  @for (item of eventsAction.columns.fullColumnList; track item) {
                    <li
                      [class.d-none]="config.group.paramsToInclude?.indexOf(item.column.key) === -1"
                      (click)="onChangeGroup(item.column, $event.target)" class="plus-item"
                      [attr.data-group-key]="item?.column?.key">
                      {{item.column.value}}
                    </li>
                  }
                </ul>
              </div>
            </div>
            <button (click)="onGroupValidation($event.target)"
            class="action-filter-btn-add icon-check btn-group-validation"></button>
          </div>
        </div>
      </div>
    }
    <!-- SEARCH -->
    @if (config.search) {
      <div class="sort-filter action-filter" [class.filter-active]="!eventsAction.filter.filtersAreDefault()">
        <button class="action-filter-btn btn-2" (click)="onActionFilterBtnToggle($event.target)">
          <i class="icon-search"></i>
          <span [translate]="'action.filter.search'" class="translate--text"></span>
        </button>
        <div class="action-filter-content">
          <p class="action-filter-content-label" [translate]="'action.filter.search_by'"
            class="translate--text">
          </p>
          <div class="action-filter-row">
            <input type="text" placeholder="Terme à rechercher" class="action-filter-element"
              (keyup)="onChangeFilterTerm($event)"  (keydown.enter)="onPressEnterInSearch($event)">
            <div class="plus-wrap">
              <div class="action-filter-select-wrap" (click)="togglePlusContent($event.target, 'next')">
                <button class="action-filter-select"
                (click)="togglePlusContent($event.target, 'parent-next')">{{eventsAction.filter?.value?.value}}</button>
                <span class="icon-chevron-down plus-toggle"
                (click)="togglePlusContent($event.target, 'parent-next')"></span>
              </div>
              <div class="plus-content">
                <span class="icon-chevron-up plus-toggle"
                (click)="togglePlusContent($event.target, 'parent')"></span>
                <ul>
                  @if (!hidefilterAll) {
                    <li (click)="onChangeFilterSelect({key: 'ALL', value: 'Tout'}, $event.target)"
                    class="plus-item">{{'action.filter.all' | translate}}</li>
                  }
                  @if (!config.column?.fullColumnList && config.search) {
                    <ng-container #searchOnly>
                      @for (item of config.search?.paramsToInclude; track item) {
                        <li
                          (click)="onChangeFilterSelect({key: item, value: item}, $event.target)" class="plus-item">
                        {{item}}</li>
                      }
                    </ng-container>
                  } @else {
                    @for (item of eventsAction.columns.fullColumnList; track item) {
                      <li
                        [class.d-none]="config.search.paramsToInclude?.indexOf(item.column.key) === -1"
                        (click)="onChangeFilterSelect(item.column, $event.target)" class="plus-item">
                      {{item.column.value}}</li>
                    }
                  }
                </ul>
              </div>
            </div>
            <button class="action-filter-btn-add icon-plus" (click)="addFilterItem($event.target)"></button>
          </div>
          <div class="action-filter-row">
            <ul class="action-filter-parent-element">
              @for (filter of eventsAction.filter.filters; track filter) {
                <li
                  class="action-filter-element small-item">
                  <span class="action-filter-row-label">
                    {{filter.value}} ({{filter.field.value}})
                  </span>
                  <button class="action-filter-remove" (click)="removeFilterItem(filter)">
                    <span class="icon-minus-circle"></span>
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
    }

    <!--UNSELECTED-->
    @if (displayUnselect) {
      @if (config.group) {
        <div class="">
          <button [matTooltip]="'action.filter.unselect'| translate" class="btn_app table-action" (click)="OnUnselect($event.target)">
            <span class="icon-check-square-offset"></span>
          </button>
        </div>
      }
    }
    <!-- EXPORT -->
    @if (config.export) {
      <div class="displayColumn action-filter">
        <button class="action-filter-btn btn-2 {{isLoadingExport ? 'loading' : ''}}" (click)="exportData()">
          <i class="spinner icon-loader"></i>
          <i class="fas fa-file-download download-icon"></i>
          <span [translate]="'action.export'" class="translate--text"></span>
        </button>
      </div>
    }
    <!-- VIEW -->
    @if (config.view) {
      <div class="displayColumn action-filter">
        @if (viewType === 'list') {
          <button class="action-filter-btn btn-2" (click)="onClickView()">
            <i class="fas fa-list"></i>
            <span [translate]="'action.filter.view'"></span>
          </button>
        }
        @if (viewType === 'grid') {
          <button class="action-filter-btn btn-2" (click)="onClickView()">
            <i class="fas fa-th-large"></i>
            <span [translate]="'action.filter.view'"></span>
          </button>
        }
      </div>
    }
  </div>
</div>
